var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModelZFeature2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 37.5C18 39.0913 18.6321 40.6174 19.7574 41.7426C20.8826 42.8679 22.4087 43.5 24 43.5C25.5913 43.5 27.1174 42.8679 28.2426 41.7426C29.3679 40.6174 30 39.0913 30 37.5C30 35.9087 29.3679 34.3826 28.2426 33.2574C27.1174 32.1321 25.5913 31.5 24 31.5C22.4087 31.5 20.8826 32.1321 19.7574 33.2574C18.6321 34.3826 18 35.9087 18 37.5Z",
    stroke: "#008F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5997 26.894C31.7867 24.0813 27.9716 22.5012 23.9937 22.5012C20.0157 22.5012 16.2007 24.0813 13.3877 26.894",
    stroke: "#008F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9703 20.53C36.4694 16.0295 30.3652 13.5011 24.0003 13.5011C17.6354 13.5011 11.5311 16.0295 7.03027 20.53",
    stroke: "#008F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 13.362C40.3912 7.66825 32.3509 4.50223 24 4.50223C15.6491 4.50223 7.60883 7.66825 1.5 13.362",
    stroke: "#008F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgModelZFeature2;